import React, { useState  } from "react";
import Logo from "../../common/mobile/Logo";
import { Link } from "react-router-dom";

const Footer = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const origin = window.location.origin.replace(/^https?:\/\/(www\.)?/, '').replace(/(\.com|\.live|\.net)$/i, '');
   

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };
    return (
        <div  className="ng-tns-c855548785-1 ng-trigger ng-trigger-footerFadeInAni ng-star-inserted" style={{}}>
       
          <footer  className="footer ng-star-inserted">
           
              
            <div  className="footer-top">
              <div  className="list list--sponsor-data">
                <div  className="list__title">Sponsorships</div>
                <div  className="list__wrap">
                  <div  className="list__item item">
                    <div  className="item__icon">
                      <img  mcdsrc="/assets/images/sponsor/delhi-bulls.png" alt="icon-sponsor" src="https://img.j189eb.com/jb/h5/assets/images/sponsor/delhi-bulls.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      <div  className="item__content">
                        <div  className="txt">Delhi Bulls</div>
                        <div  className="sub-txt">
                          <span >Title Sponsor</span><span > 2023 - 2024 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  className="list list--ambassador-data">
                <div  className="list__title">Brand Ambassadors</div>
                <div  className="list__wrap">
                  <div  className="list__item item">
                    <img  mcdsrc="/assets/images/footer/ambassador_signature/andre-russell.png" className="list__item--img" alt="andre-russell" src="https://img.j189eb.com/jb/h5/assets/images/footer/ambassador_signature/andre-russell.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                    <div  className="item__content">
                      <div  className="txt">Andre Dwayne Russell</div>
                      <div  className="sub-txt"><span > 2024 - 2026 </span></div>
                    </div>
                  </div>
                  <div  className="list__item item">
                    <img  mcdsrc="/assets/images/footer/ambassador_signature/mcgrath.png" className="list__item--img" alt="mcgrath" src="https://img.j189eb.com/jb/h5/assets/images/footer/ambassador_signature/mcgrath.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                    <div  className="item__content">
                      <div  className="txt">Glenn McGrat</div>
                      <div  className="sub-txt"><span > 2023 - 2024 </span></div>
                    </div>
                  </div>
                </div>
              </div>
             
                <div  className="pay ng-star-inserted">
                  <h2 >Payment Methods</h2>
                  <ul >
                    <li  className="ng-star-inserted">
                      <img  alt="pay16" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay16.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay22" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay22.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay33" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay33.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay34" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay34.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay45" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay45.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay59" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay59.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay60" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay60.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay61" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay61.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay47" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay47.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <img  alt="pay91" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/pay91.png?v=1729676340443&source=mcdsrc" loading="lazy" className="ng-star-inserted" />
                      
                    </li>
                    
                  </ul>
                </div>
                
            
                <div  className="safe ng-star-inserted">
                  <h2 >Responsible Gaming</h2>
                  <ul >
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="Gamcare" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/gamcare.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="18 Policy" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/age-limit.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                    <li  className="ng-star-inserted">
                      <Link  target="_blank" href="#" className="ng-star-inserted">
                        <img  alt="Responsible Gaming" src="https://img.j189eb.com/jb/h5/assets/images/footer/white/safe/regulations.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                      </Link>
                      
                    </li>
                    
                  </ul>
                </div>
            </div>
            <div  className="footer-middle">
              <div  className="gaming-license">
                <h2 >
                  <p >Gaming License</p>
                </h2>
                <ul >
                  <li >
                    <img  mcdsrc="/assets/images/footer/gaming_license.png" alt="gaming_license" src="https://img.j189eb.com/jb/h5/assets/images/footer/gaming_license.png?v=1729676340443&source=mcdsrc" loading="lazy" />
                  </li>
                </ul>
              </div>
              <div className="ng-star-inserted">
                <h2>APP Download</h2>
                <a   href={`./app/${origin}.apk`}>
                  <img
                   
                    mcdsrc="/assets/images/footer/android-en.png"
                    alt="APP Download"
                    src="https://img.j189eb.com/jb/h5/assets/images/footer/android-en.png?v=1737451131402&source=mcdsrc"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
            <div  className="footer-bottom">
              <Logo/>
              <div  className="text">
                <div  className="title">Catch the winning </div>
                <p >© 2024 {origin} Copyrights. All Rights Reserved</p>
              </div>
            </div>
          </footer>
      </div>
      
    );
};

export default Footer;
